type CommitHandler = () => Promise<void> | void;

const handlers = new Set<CommitHandler>();

export function registerFormCommit(handler: CommitHandler): () => void {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}

export async function flushFormCommits(): Promise<void> {
  const errors: Error[] = [];

  // Snapshot so a handler unregistering itself mid-iteration is safe.
  for (const handler of [...handlers]) {
    try {
      await handler();
    } catch (err) {
      console.warn("Form commit handler failed", err);
      errors.push(
        err instanceof Error ? err : new Error("Form commit handler failed"),
      );
    }
  }

  if (errors.length > 0) {
    throw errors[0];
  }
}
